import PropTypes from 'prop-types';
import React from 'react';
import './styles.scss';

function Message({ role, content }) {
  const isThinking = role === 'assistant' && content === '';
  const senderName = role === 'user' ? 'Tú' : 'Assistant';

  return (
    <div className={`message ${role}`}>
      <div className='sender'>{senderName}</div>
      <div className='content'>
        {isThinking ? (
          <span className='thinking-dots'>
            <span className='dot'>.</span>
            <span className='dot'>.</span>
            <span className='dot'>.</span>
          </span>
        ) : (
          <span>{content}</span>
        )}
      </div>
    </div>
  );
}

Message.propTypes = {
  role: PropTypes.oneOf(['user', 'assistant']).isRequired,
  content: PropTypes.string.isRequired,
};

export default Message;
